import AbstractPolyShape from "./AbstractPolyShape";

export default class Line extends AbstractPolyShape {
    type = 'line';

    constructor(provider, data, appearance, speciesIds, label) {
        super(provider, data, appearance, speciesIds, label);
        this.close = null;
    }

    displayHighlight(g) {
        if (!this.highlight) return;
        const colorMap = {
            flash: 'rgb(200, 0, 150)',
            hovered: 'rgb(255, 255, 0)',
            selected: 'rgb(255, 130, 0)',
        };
        g.push();
        g.stroke(colorMap[this.highlight]);
        g.strokeWeight(this.appearance.scaledStrokeWidth + 5);
        g.strokeJoin(g.ROUND);
        g.strokeCap(g.SQUARE);
        g.noFill();
        g.beginShape();
        this.segments.forEach(seg => seg.display(g));
        g.endShape();
        g.pop();
    }

    clone(dx, dy) {
        return new Line(
            this.provider,
            {
                coordinates: this.exportCoordinates(dx, dy),
                layer: this.layer?.id,
                addedDate: this.addedDate,
                removedDate: this.removedDate,
            },
            this.appearance.clone(),
            this.speciesIds,
            this.labels.clone(),
        );
    }

    hovered() {
        const tolerance = Math.max(7, this.appearance.scaledStrokeWidth / 2);
        const mx = this.view.currentX;
        const my = this.view.currentY;
        return this.segments.some(seg => seg.hovered(mx, my, tolerance));
    }

    export() {
        return {
            type: 'line',
            data: {
                coordinates: this.exportCoordinates(),
                notes: this.notes,
                addedDate: this.addedDate,
                removedDate: this.removedDate,
                layer: this.layer?.id,
                ...this.appearance.export(),
                ...this.labels.export(),
            },
            speciesIds: this.speciesIds,
        }
    }

    isPolygon() {
        return false;
    }

    get length() {
        return this.segments.length;
    }

    get displayTotalLength() {
        let total = 0;
        for (let i = 0; i < this.length; i++) {
            total += this.segmentLength(i);
        }
        return Math.round(total * 100) / 100;
    }
}
